import { AccordionInputs } from './Accordion';

export const accordionTransformer = (node): AccordionInputs => {
    return {
        title: node.field_component_title,
        items: node.relationships?.field_accordion_items.map((item, idx) => ({
            visibleText: item.field_visible,
            hiddenText: item.field_hidden.value,
            expanded: idx === 0,
            id: item.id,
        })),
    };
};
